module.exports = __webpack_public_path__ + "static/media/team11.a40bdb1d.png";